<template>
  <v-app-bar color="primary" dark flat app>
    <router-link to="/dashboard">
      <v-img class="mx-2" :src="urlLogo" max-width="100" width="70px" contain></v-img>
    </router-link>
    <v-spacer></v-spacer>
    <ProgressCircular v-if="progressCircular" :value="porcentagemRespostasPsicossocial" text="Progresso" />
    <Notifications />
    <v-menu left bottom offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="#fff"
          icon
          v-bind="attrs"
          v-on="on"
          :style="{ backgroundColor: $vuetify.theme.themes.light.secondary }"
        >
          <v-icon>mdi-account-outline</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="goTo('minha-conta')">
          <v-list-item-avatar>
            <v-icon size="18" color="primary">mdi-account</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Minha conta</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="logout()">
          <v-list-item-avatar>
            <v-icon size="18" color="primary">mdi-logout</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Sair</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import authenticationService from '@/services/authentication'
import ProgressCircular from './ProgressCircular.vue'
import Notifications from './Notifications.vue'
import { mapGetters, mapActions } from 'vuex'
import porcentagemRespostasPsicossocial from '@/core/mixins/porcentagemRespostasPsicossocial'

export default {
  components: {
    Notifications,
    ProgressCircular
  },
  mixins: [porcentagemRespostasPsicossocial],
  computed: {
    ...mapGetters('user', ['urlLogo', 'colorTheme']),
    progressCircular() {
      return this.$route.meta.progressCircular
    },
  },
  methods: {
    ...mapActions('user', ['logoutUser']),
    goTo(page) {
      this.$router.push({ name: page })
    },
    logout() {
      authenticationService.logout()
      this.logoutUser()
      this.$router.push({ name: 'Login' })
    },
    lightenHexColor(hex, percent) {
      hex = hex.replace(/^#/, '')
      if (hex.length === 3) {
        hex = hex
          .split('')
          .map(c => c + c)
          .join('')
      }

      let num = parseInt(hex, 16)
      let r = (num >> 16) + Math.round((255 - (num >> 16)) * percent)
      let g = ((num >> 8) & 0x00ff) + Math.round((255 - ((num >> 8) & 0x00ff)) * percent)
      let b = (num & 0x0000ff) + Math.round((255 - (num & 0x0000ff)) * percent)

      r = Math.min(255, r)
      g = Math.min(255, g)
      b = Math.min(255, b)

      return `#${((1 << 24) | (r << 16) | (g << 8) | b)
        .toString(16)
        .slice(1)
        .toUpperCase()}`
    }
  },
  created() {
    this.$vuetify.theme.themes.light.primary = this.colorTheme
    this.$vuetify.theme.themes.light.secondary = this.lightenHexColor(this.colorTheme, 0.2)
    this.$vuetify.theme.themes.light.tertiary = this.lightenHexColor(this.colorTheme, 0.78)
    this.$vuetify.theme.themes.light.soft = this.lightenHexColor(this.colorTheme, 0.95)
  }
}
</script>

<style scoped>
.btn-color {
  background-color: #6a9bff;
}
</style>
